import React from 'react';
import { Navigate } from 'react-router-dom';
import store from 'store';

const AuthGuard = ({ children }) => {
  const authToken = store.get('authenticationToken');

  // If no authentication token exists, redirect to login
  if (!authToken) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the protected content
  return children;
};

export default AuthGuard;
